import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);
const AttributeCodec = t.intersection([
  t.type({
    Model: t.string,
    WorkstationId: t.string,
    EBID: t.string,
    Active: t.boolean
  }),
  t.partial({
    BSB: t.string,
  }),
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const WorkstationCodec = t.type(
  {
    errors: tOptional(t.array(ErrorCodec)),
    data: tOptional(t.array(DataCodec)),
  },
  "WorkstationCodec"
);

export type Workstation = t.TypeOf<typeof WorkstationCodec>;

export enum WorkstationActionTypes {
  FETCH = "@@workstation/FETCH",
  FETCH_SUCCESS = "@@workstation/FETCH_SUCCESS",
  FETCH_ERROR = "@@workstation/FETCH_ERROR",
  SAVE_REQUEST = "@@workstation/SAVE_REQUEST",
  SAVE_SUCCESS = "@@workstation/SAVE_SUCCESS",
  SAVE_ERROR = "@@workstation/SAVE_ERROR",
  DELETE_REQUEST = "@@workstation/DELETE_REQUEST",
  DELETE_SUCCESS = "@@workstation/DELETE_SUCCESS",
  DELETE_ERROR = "@@workstation/DELETE_ERROR",
}

export interface WorkstationState {
  readonly loading: boolean;
  readonly data: Workstation | undefined;
  readonly errors?: string;
}
